import Vue from 'vue'
import VueRouter from 'vue-router'

import Contact from '../views/Contact.vue'
import Dogs from '../views/Dogs.vue'
import Litters from '../views/Litters.vue'
import Pedigree from '../views/Pedigree.vue'
import Puppy from '../views/Puppy.vue'
import About from '../views/About.vue'
import AboutDog from '../views/AboutDog.vue'
import Documents from '../views/Documents.vue'


Vue.use(VueRouter)


const routes = [
	{ path: '/', name: 'AboutDog', component: AboutDog, },
	{ path: '/contacts', name: 'Contact', component: Contact, },
	{ path: '/dogs_:sex', name: 'Dogs', component: Dogs, },
	{ path: '/litters', name: 'Litters', component: Litters, },
	{ path: '/pedigree_litter_:id', name: 'Pedigree', component: Pedigree, props:true,},
	{ path: '/puppy', name: 'Puppy', component: Puppy, },
	{ path: '/about', name:'About', component: About,},
	//{ path: '/about', name: 'About', component: () => import(/* webpackChunkName: "about" */ '../views/About.vue') }
	{ path: '/documents', name:'Documents', component: Documents,},

]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
